import { useState, useEffect, useRef } from 'react';
import './App.css';
import './styleAudio.css';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import banner from './media/micBanner.webp';
// TODO remove this once we verify the new one is good
//import headshot from './media/headshot.webp';
import newHeadshot from './media/adrienne.jpg';
import playIcon from './media/playIcon.png';
import pauseIcon from './media/pauseIcon.png';


import animationAudio0 from './media/animationDemo.mp3';
import animationAudio1 from './media/1-SOLDIER.mp3';
import animationAudio2 from './media/2-YOUNG-GIRL.mp3';
import animationAudio3 from './media/3-YOUNG-BOY.mp3';
import animationAudio4 from './media/4-TEEN-GIRL.mp3';
import animationAudio5 from './media/5-COMPUTER.mp3';
import animationAudio6 from './media/6-NEW-YORK-BUSINESS-WOMAN.mp3';
import animationAudio7 from './media/7-TRANSATLANTIC.mp3';
import animationAudio8 from './media/8-TEEN-BOY.mp3';



import audio0 from './media/commercialDemo.mp3';
import audio1 from './media/bmw.mp3';
import audio2 from './media/disney.mp3';
import audio3 from './media/eHarmony.mp3';
import audio4 from './media/juice.mp3';
import audio5 from './media/leslie.mp3';
import audio6 from './media/lush.mp3';


const animationtrackList = [
  { sound: animationAudio0, name: 'ANIMATION DEMO', len: '01:48' },
  { sound: animationAudio1, name: 'SOLDIER', len: '00:13' },
  { sound: animationAudio2, name: 'YOUNG GIRL', len: '00:18' },
  { sound: animationAudio3, name: 'YOUNG BOY', len: '00:15' },
  { sound: animationAudio4, name: 'TEEN GIRL', len: '00:17' },
  { sound: animationAudio5, name: 'COMPUTER', len: '00:12' },
  { sound: animationAudio6, name: 'NEW YORK BUSINESS WOMAN', len: '00:18' },
  { sound: animationAudio7, name: 'TRANSATLANTIC', len: '00:21' },
  { sound: animationAudio8, name: 'TEEN BOY', len: '00:15' }
];

const commercialTrackList = [
  { sound: audio0, name: 'COMMERCIAL DEMO', len: '01:14' },
  { sound: audio1, name: 'BMW iX (Standalone)', len: '00:22' },
  { sound: audio2, name: 'Disney Princess Celebration Castle (Standalone)', len: '00:18' },
  { sound: audio3, name: 'eHarmony (Standalone)', len: '00:18' },
  { sound: audio4, name: 'Naked Juice (Standalone)', len: '00:14' },
  { sound: audio5, name: 'Leslie\'s Pool Supplies (Standalone)', len: '00:19' },
  { sound: audio6, name: 'Lush Cosmetics (Standalone)', len: '00:20' }
];

function useResponsiveAudioSettings() {
  const [vol, setVol] = useState([RHAP_UI.VOLUME]);
  const [jump, setJump] = useState(true);

  useEffect(() => {
    function handleResize() {
      const width = window.innerWidth;
      if (width < 500) {
        setVol([]);
        setJump(false);
      } else if (width < 1000) {
        setVol([]);
        setJump(true);
      } else {
        setVol([RHAP_UI.VOLUME]);
        setJump(true);
      }
    }

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { vol, jump };
}

function AudioBlock({ trackList, title }) {
  const [selection, setSelection] = useState(0);
  const [song, setSong] = useState(trackList[0].sound);
  const playerRef = useRef();
  const { vol, jump } = useResponsiveAudioSettings();

  useEffect(() => {
    setSong(trackList[selection].sound);
  }, [selection, trackList]);

  const handleListClick = (index) => {
    if (index === selection) {
      const audio = playerRef.current.audio.current;
      if (audio.paused) audio.play();
      else audio.pause();
    } else {
      document.getElementById(`popin${title}${selection}`).src = playIcon;
      setSelection(index);
    }
  };

  const handlePlay = () => {
    document.getElementById(`popin${title}${selection}`).src = pauseIcon;
  };

  const handlePause = () => {
    document.getElementById(`popin${title}${selection}`).src = playIcon;
  };

  const handlePrevClick = () => {
    setSelection(prev => prev === 0 ? trackList.length - 1 : prev - 1);
  };

  const handleNextClick = () => {
    setSelection(prev => (prev + 1) % trackList.length);
  };

  return (
    <div className="media-container">
      <h6 className="media-name">{title}</h6>
      <h5 title={trackList[selection].name}>{trackList[selection].name}</h5>
      <h6>Reel and Standalones</h6>
      <AudioPlayer
        ref={playerRef}
        src={song}
        showSkipControls={true}
        showJumpControls={jump}
        customVolumeControls={vol}
        onPlay={handlePlay}
        onPause={handlePause}
        onClickPrevious={handlePrevClick}
        onClickNext={handleNextClick}
      />
      <ul>
        {trackList.map((item, index) => (
          <li key={index} onClick={() => handleListClick(index)}>
            <p className="track-list num">
              <img id={`popin${title}${index}`} className="popin" src={playIcon} alt="play" />
              {index + 1}
            </p>
            <p className="track-list name" title={item.name}>{item.name}</p>
            <p className="track-list time">{item.len}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={banner} id="banner" className="App-banner" alt="banner" />
        <div id="title" className='title-text'>
          <h1>Adrienne<br />Crawford</h1>
          <h3>
            <span style={{fontWeight: "bold"}}>Email:</span> adrienne.crawford.vo@gmail.com<br />
            <span style={{fontWeight: "bold"}}>Phone:</span> (928) 202-0039
          </h3>
        </div>
      </header>
      <div id="main" className="columns">
        <div className="right-column">
          <img src={newHeadshot} className="photo" alt="headshot" />
        </div>
        <div className="left-column">
          <h4>Voice Actor</h4>
          <br />
          <p>Adrienne is a first-generation Filipino-American voice actor based in Los Angeles, CA, represented by Dean Panaro Talent. She records from her broadcast-quality home studio with Source-Connect - as well as from local LA studios - and is available for your next project. Having worked with some of the top names in the voice over industry, such as director Kal-El Bogdanove (known for Skyrim, Farcry 5, the Fallout game series, and Helldivers II), she brings top-tier voice over to any project she takes part in. Adrienne has been cast in video games, Netflix series, commercials, e-learning, corporate narration, and more (<a href="https://drive.google.com/file/d/1xEqX64GItbH00tCmJNSMUr5tGcCY49Ta/view?usp=sharing">see her resume here.</a>)</p>
          <p>She's had extensive training in all types of voice over, including private coaching with legendary animation voice actor Debi Derryberry (Jimmy Neutron), voice actor Crispin Freeman (known for his iconic roles in Japanese anime, games and more), veteran commercial voice actor Marc Cashman, and many other well-known names in the voice over industry.</p>
          <p>Adrienne is highly-trained in child voices, and is able to play female characters from toddlers to mature adults, as well as male characters from toddlers to mid-teens. She's also a professionally-trained singer, and is able to sing both in and out of character. For professional inquiries, please contact her directly via email or phone, or reach out to her agents at Dean Panaro Talent.</p>
          <p style={{ fontSize: 14.5, fontWeight: 'bold' }}>
            Rep: Dean Panaro Talent<br />
            Agent: Brandie Ilsen<br />
            Agent Email: brandie@deanpanarotalent.com
          </p>
          <AudioBlock trackList={animationtrackList} title="Adrienne Crawford" />
          <div>
            <a
              href={animationAudio0}
              download="animationDemo.mp3" // Suggests a default filename for the download
              className="download-button"
              >
                DOWNLOAD ANIMATION DEMO
            </a>
          </div>
          <AudioBlock trackList={commercialTrackList} title="Adrienne Crawford" />
          <div>
            <a
              href={audio0}
              download="commercialDemoDemo.mp3" // Suggests a default filename for the download
              className="download-button"
              >
                DOWNLOAD COMMERCIAL DEMO
            </a>
          </div>
        </div>
      </div>
      <div className="footerCopy">© 2025 Adrienne Crawford Voice Over</div>
    </div>
  );
}

export default App;
